import { render, staticRenderFns } from "./AcceptInvitationForm.vue?vue&type=template&id=72da1c0d&scoped=true&"
import script from "./AcceptInvitationForm.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da1c0d",
  null
  
)

export default component.exports